/**
 * Application Configurations
 * Centralized configuration for environment variables
 */

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = 
  process.env.REACT_APP_GOOGLE_CLIENT_ID || 
  '610696728606-hjv0463opi1e5umn1nas2e3589ss9dqv.apps.googleusercontent.com';

// API Configuration
export const API_URL = 
  process.env.REACT_APP_API_URL || 
  'https://aptirix-version-610696728606.asia-south1.run.app/api';

// API Base URL (alias for consistency)
export const API_BASE_URL = API_URL;

// Fallback API URL for direct usage
export const FALLBACK_API_URL = 'https://aptirix-version-610696728606.asia-south1.run.app/api';

// reCAPTCHA Configuration
export const RECAPTCHA_SITE_KEY = 
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || 
  '6LfZlYMsAAAAAO1w-iwuikuGWi4DctZvjTbwEtMt'; // Fallback to production key

// Debug: Log configuration on load
console.log('🔧 App Configuration:', {
  GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID ? `${GOOGLE_CLIENT_ID.substring(0, 20)}...` : 'NOT SET',
  API_URL,
  API_BASE_URL,
  RECAPTCHA_SITE_KEY: RECAPTCHA_SITE_KEY ? 'SET' : 'NOT SET'
});
